module.exports = __webpack_public_path__ + "static/media/la.ff505eba.webp";